module.exports = __webpack_public_path__ + "static/media/bolso (13).9eca5614.jpg";